"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3948],{

/***/ 73948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26706);
/* harmony import */ var src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13508);




var StoreNameAndLogo = function(param) {
    var _logoImage = param.logoImage, logoImage = _logoImage === void 0 ? "" : _logoImage, _storeName = param.storeName, storeName = _storeName === void 0 ? "" : _storeName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "tw-flex tw-items-center tw-gap-16 tw-p-20",
        children: [
            !!logoImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-flex tw-items-center tw-rounded-md tw-border tw-border-solid tw-border-[#111C3626]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: logoImage,
                    height: 40,
                    width: 40,
                    className: "tw-flex tw-items-center"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-flex tw-items-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "tw-m-0 tw-font-inter tw-text-18 tw-font-semibold tw-text-newBlack",
                    children: storeName
                })
            })
        ]
    });
};
var HeadingSection = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "tw-mt-18 tw-flex-grow tw-p-20 tw-font-inter tw-font-bold tw-text-newBlack",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "tw-m-0 tw-max-w-[70%] tw-text-[52px]",
                children: "Coming Soon..."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "tw-m-0 tw-mt-24 tw-text-16 tw-font-normal tw-opacity-60",
                children: "We're almost there. Stay tuned!"
            })
        ]
    });
};
var ImageSection = function() {
    var desktopImg = "https://cdn.dotpe.in/longtail/custom_website/7593060/ag9VV4xL.gif";
    var mobileImg = "https://cdn.dotpe.in/longtail/custom_website/7593060/vJV1GIrD.gif";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-flex tw-items-end tw-justify-end",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: src_utils_checkClientDeviceType__WEBPACK_IMPORTED_MODULE_3__/* .IS_DESKTOP */ .yn ? desktopImg : mobileImg,
            className: "tw-max-h-[500px]"
        })
    });
};
var LaunchingSoon = function() {
    var storeData = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_2__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var logo_image = storeData.logo_image, store_name = storeData.store_name;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
        className: "tw-flex tw-h-screen tw-flex-col tw-bg-white",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StoreNameAndLogo, {
                logoImage: logo_image,
                storeName: store_name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeadingSection, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageSection, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LaunchingSoon);


/***/ })

}]);